import React, { FC } from "react";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { Description } from "@/components/YhBox/Description";
import useGlobalModel from "@/model/globalModel";
import { RouterParamType } from "@/model/navModel";
import { useStockCheckDetailModel } from "./stockCheckDetailsModel";
import { formatNum } from "@/utils/utils";


export const FixedBottom: FC<RouterParamType> = ({ id, mode }) => {

    const { cm } = useGlobalModel()

    const { addDesc, lookDesc, editDesc } = useStockCheckDetailModel();
    const typeDesc = {
        add: addDesc,
        edit: editDesc,
        look: lookDesc
    }
    const orderStatistics: IDescription[] = [
        {
            label: "系统库存",
            value: formatNum(typeDesc[mode].stockAll),
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: "实际库存",
            value: formatNum(typeDesc[mode].checkAll),
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: "盘盈项数",
            value: (typeDesc[mode].SurplusNumAll),
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: "盘亏项数",
            value: (typeDesc[mode].deficitNumAll),
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: "差异数量",
            value: typeDesc[mode].differenceNumAll >= 0 ? formatNum(typeDesc[mode].differenceNumAll) : -formatNum(typeDesc[mode].differenceNumAll),
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: "差异金额",
            value: typeDesc[mode].differenceMoneyAll >= 0 ? formatNum(typeDesc[mode].differenceMoneyAll) : -formatNum(typeDesc[mode].differenceMoneyAll),
            color: DescriptionColorEnum.green,
            status: true
        },
        // {
        //     label: "数量差异率",
        //     value: isNaN(typeDesc[mode].differenceRateNumAll) ? "0%" : formatNum((typeDesc[mode].differenceRateNumAll)) + "%",
        //     color: DescriptionColorEnum.green,
        //     status: true
        // },
        // {
        //     label: "金额差异率",
        //     value: isNaN(typeDesc[mode].differenceRateAll) ? "0%" : formatNum((typeDesc[mode].differenceRateAll)) + "%",
        //     color: DescriptionColorEnum.green,
        //     status: true
        // },
    ]
    return (
        <div className="details-bot-fixed-warp" style={{ width: `calc(100% - ${cm.collapsed ? '80px' : '226px'})`, paddingLeft: "43px" }}>
            {orderStatistics.map((item, index) => <Description key={index} {...item} />)}
        </div>
    )
}